// extracted by mini-css-extract-plugin
var _1 = "ControlBarActivityButton-module__hasNewActivities--rcvcS";
var _2 = "ControlBarActivityButton-module__hasUnresolvedCommentThreads--odq8x";
export { _1 as "hasNewActivities", _2 as "hasUnresolvedCommentThreads" }
